import { call, put, takeLatest } from 'redux-saga/effects';
import { AnnouncementIndividualTypes } from '../redux/AnnouncementIndividualRedux';
import AnnouncementIndividualActions from '../redux/AnnouncementIndividualRedux';
import { api } from './api';

/* ------------- Types ------------- */

export interface AnnouncementIndividualSaga {
  getAnnouncementIndividual: () => Generator<any, any, any>;
}

/* ------------- Sagas ------------- */

export function* getAnnouncementIndividual(action: any): Generator<any, void, any> {
  try {
    const { announcementId } = action;
    
    // Call API to get individual announcement
    const response = yield call(api.getAnnouncementIndividual, announcementId);
    
    if (response.ok) {
      // Extract announcement data from response
      const announcement = response.data?.data || response.data || null;
      
      // Dispatch success action with announcement data
      yield put(AnnouncementIndividualActions.getAnnouncementIndividualSuccess(announcement));
    } else {
      // Handle API error response
      const error = response.problem || 'Failed to fetch announcement';
      yield put(AnnouncementIndividualActions.getAnnouncementIndividualFailure(error));
    }
  } catch (error) {
    // Handle unexpected errors
    console.error('getAnnouncementIndividual saga error:', error);
    yield put(AnnouncementIndividualActions.getAnnouncementIndividualFailure(error));
  }
}

/* ------------- API ------------- */

// Note: getAnnouncementIndividual method is now properly implemented in src/services/Api.ts

/* ------------- Connect Types To Sagas ------------- */

export default function* announcementIndividualSaga() {
  yield takeLatest(
    AnnouncementIndividualTypes.GET_ANNOUNCEMENT_INDIVIDUAL_REQUEST,
    getAnnouncementIndividual
  );
}
